import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DateRange } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { Moment } from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { IAddHourlyWage } from '../../../../../models/add-hourly-wage-model';
import { ICostCenter } from '../../../../../models/cost-center.model';
import { IHourlyWage } from '../../../../../models/hourly-wage-model';
import { ICostCenterState } from '../../../../../services/facades/master-data/cost-center-state.model';
import { CostCenterFacade } from '../../../../../services/facades/master-data/cost-center.facade';
import { stringToMoment } from '../../../../../utils/moment-utils';

@Component({
    templateUrl: './add-wage-dialog.component.html',
    styleUrls: [ './add-wage-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddWageDialog implements OnInit, AfterViewInit {

    public costCenterState$: Observable<ICostCenterState>;
    public formGroup: FormGroup;
    public dialogFieldsValid$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        @Inject(MAT_DIALOG_DATA) public costCenter: ICostCenter,
        private myMatDialogRef: MatDialogRef<AddWageDialog>,
        private myCostCenterFacade: CostCenterFacade,
    ) {
    }

    public ngOnInit(): void {
        this.costCenterState$ = this.myCostCenterFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((wage: { costAccountingTypeId: number, validity: DateRange<Moment>, hourlyWageEuro: number }) => {
            this.validateDialogFields(this.transformDialogData(wage));
        });
    }

    public async onSave(): Promise<void> {
        const addWage: IAddHourlyWage = this.transformDialogData(this.formGroup.value);

        const addedWage: IHourlyWage = await this.myCostCenterFacade.addHourlyWage(this.costCenter.id, addWage);
        if (addedWage !== null) {
            this.closeDialog(true);
        }
    }

    public closeDialog(refresh: boolean): void {
        this.myMatDialogRef.close(refresh);
    }

    private validateDialogFields(wage: IAddHourlyWage): void {
        if (isNullOrUndefined(wage.costAccountingTypeId)
            || isNullOrUndefined(wage.hourlyWageCt)
            || wage.hourlyWageCt <= 0
            || isNullOrUndefined(wage.from)
            || isNullOrUndefined(wage.to)
            || wage.from.isAfter(wage.to)) {
            this.dialogFieldsValid$.next(false);
        } else {
            this.dialogFieldsValid$.next(true);
        }
    }

    private transformDialogData(wage: { costAccountingTypeId: number, validity: DateRange<moment.Moment>, hourlyWageEuro: number }): IAddHourlyWage {
        return {
            costAccountingTypeId: wage.costAccountingTypeId,
            hourlyWageCt: wage.hourlyWageEuro * 100,
            from: stringToMoment(wage.validity.start),
            to: stringToMoment(wage.validity.end),
        };
    }
}
